import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as moment from 'moment';
import Pagination from '@material-ui/lab/Pagination';
import { setUserInfoDetails } from '../../../../../../redux/actions/admin';
import { MdCheck, MdClear, MdWarning } from "react-icons/md";
import { AiOutlineDelete, AiOutlineSearch } from "react-icons/ai";
import { BiUndo } from "react-icons/bi";
import { showAppLoader, hideAppLoader } from 'redux/actions/app'
import { addminNewUserList } from '../../../../../../redux/actions/admin';
import Spinner from '../../../../../components/Spinner'
import axioPath from '../../../../../../api/axioPath';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SearchWrapper } from '../dashBoardStyled'
import CsvDownloader from 'react-csv-downloader';
//table
import { Table } from 'reactstrap';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { stateConvert } from 'web/components/utils/stateAbbreviation';
function UserRequest(props) {
    let dispatch = useDispatch()
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [modal, setModal] = useState(false);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
    const [warningApproveModal, setWarningApproveModal] = useState(false);
    const [modalMessage, setModalMessaage] = useState('')
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [dataList, setDataList] = useState([])
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [pageLoader, setPageLoader] = useState(false)
    const token = localStorage.getItem("token")

    useEffect(() => {
        // setDataList(props.data?.newUserRequest ? props.data?.newUserRequest : [])
        // setFinalData(props.data?.newUserRequest ? props.data?.newUserRequest : [])
        // //set csv data
        // setCSVDate(props.data?.newUserRequest ? props.data?.newUserRequest : [])

        setDataList(props?.data ? props.data : [])
        setFinalData(props?.data ? props.data : [])
        //set csv data
        // setCSVDate(props?.data ? props.data : [])


    }, [props])

    let headerArr = [
        { title: 'ID', },
        { title: 'Company Name', },
        { title: 'User Name', },
        { title: 'Email ID', },
        { title: 'User Type', },
        { title: 'Broker', },
        { title: 'Notes', },
        { title: 'Heard From', },
        { title: 'Date Registered', },
        { title: 'Actions', }
    ];

    //for csv download
    const columns = [
        { id: 'ID', displayName: 'ID' },
        { id: 'CompanyName', displayName: 'Company Name' },
        { id: 'UserName', displayName: 'User Name' },
        { id: 'EmailID', displayName: 'Email ID' },
        { id: 'UserType', displayName: 'User Type' },
        { id: 'Broker', displayName: 'Broker' },
        { id: 'Notes', displayName: 'Notes' },
        { id: 'HeardFrom', displayName: 'Heard From' },
        { id: 'DateRegistered', displayName: 'Date Registered' },
    ]

    const setCSVDate = (resultData) => {

        let tempCsvData = resultData.map(items => {
            let userTypeTemp
            if (items?.userDetail?.registerDTO?.accountTypeDTO?.buyer && !items?.userDetail?.registerDTO?.accountTypeDTO?.seller) userTypeTemp = 'Buyer'
            if (!items?.userDetail?.registerDTO?.accountTypeDTO?.buyer && items?.userDetail?.registerDTO?.accountTypeDTO?.seller) userTypeTemp = 'Seller'
            if (items?.userDetail?.registerDTO?.accountTypeDTO?.buyer && items?.userDetail?.registerDTO?.accountTypeDTO?.seller) userTypeTemp = 'Both'
            return ({
                ID: items?.userDetail?.authId,
                CompanyName: items?.userDetail?.registerDTO?.basicDetail?.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                UserName: items.name?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                EmailID: items.email,
                UserType: userTypeTemp,
                Broker: items?.userDetail?.isReseller ? 'Yes' : 'No',
                Notes: items.note?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                HeardFrom: items?.userDetail?.hearAbout?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " "),
                DateRegistered: items.createdAt ? moment(items.createdAt).format('MM-DD-YYYY') : ''
            })
        })
        return (tempCsvData)
        // setCsvData(tempCsvData)
    }

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        props.handleSearchPagination(1, e.target.value)

        // const search = e.target.value
        // let dataListtemp = dataList.filter(value => {
        //     return (
        //         value.authId.toString().toLowerCase().includes(search.toLowerCase()) ||
        //         value.name.toString().toLowerCase().includes(search.toLowerCase()) ||
        //         value.email.toString().toLowerCase().includes(search.toLowerCase()) ||
        //         value.companyName.toString().toLowerCase().includes(search.toLowerCase()) ||
        //         value.accountType.toString().toLowerCase().includes(search.toLowerCase()) ||
        //         value.hearAbout?.toString().toLowerCase().includes(search.toLowerCase())
        //     )
        // }
        // );
        // setFinalData(dataListtemp)
        // setCSVDate(dataListtemp)
    }

    const handleToggle = () => {
        setModal(!modal);
        props.action();
    }

    const handleConfirmationToggle = () => {
        setDeleteConfirmationModal(!deleteConfirmationModal);
        axioPath.post('/users/delete', {
            email: localStorage.getItem('NewApprovalDeleteEmail')
        }, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data.status === 'SUCCESS') {
                setModal(!modal)
                setModalMessaage('User has been deleted.')
            } else {
                setModal(!modal)
                setModalMessaage('Something went wrong, please try again in some time.')
            }
        }).catch((ex) => {
            setModal(!modal)
            setModalMessaage(ex.message)
        });
    }

    const handleIdClick = (e, index) => {
        e.preventDefault()
        axioPath.get(`/users/dalancey-to-approvedData/${dataList[index]?.userDetail?.authId}`, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            let userDetailsTemp = response?.data
            let userTypeTemp
            if (userDetailsTemp?.buyer) userTypeTemp = 'Buyer'
            if (userDetailsTemp?.seller) userTypeTemp = 'Seller'
            if (userDetailsTemp?.buyer && userDetailsTemp?.seller) userTypeTemp = 'Buyer & Seller'
            let userInfoObject = {
                userName: userDetailsTemp?.name,
                companyName: userDetailsTemp?.companyName,
                dbaName: userDetailsTemp?.dba || 'NA',
                email: userDetailsTemp?.email,
                location: `${userDetailsTemp?.city}, ${stateConvert(userDetailsTemp?.state) || userDetailsTemp?.state}, ${userDetailsTemp?.zip}`,
                accountType: userDetailsTemp?.accountType,
                parentCompany: '',
                userType: userTypeTemp,
                licenseNumber: userDetailsTemp?.licenseNumber,
                phoneNumber: userDetailsTemp?.phoneNumber,
                dnsNumber: userDetailsTemp?.dnbDuns,
                taxId: (userDetailsTemp?.taxId && userDetailsTemp?.taxId !== '') ? userDetailsTemp?.taxId : 'NA',
                webUrl: userDetailsTemp?.businessURL,
                description: userDetailsTemp?.businessDesc,
                paymentType: userDetailsTemp?.paymentType,
                buyingPaymentMethod: userDetailsTemp?.buyingPaymentMethod,
                limitAssigned: userDetailsTemp?.paymentAssignedLimit,
                sellerAccountInfo: '',
                broker: userDetailsTemp?.isReseller,
                paymentDetails: userDetailsTemp?.paymentDetails,
                promoCode: userDetailsTemp?.promoCodes,
                referralCode: userDetailsTemp?.referralCode,
                successfullInvites: userDetailsTemp?.successfullInvites,
                referralDiscountAvailed: userDetailsTemp?.referralDiscountAvailed,
                referralDescription: userDetailsTemp?.ownerDescription,
                licenseImage: userDetailsTemp?.uploadImage,
                notes: userDetailsTemp?.note,
                diverseTrackingResponse: userDetailsTemp?.diverseTrackingResponse,
            }
            dispatch(setUserInfoDetails(userInfoObject))
            history.push({
                pathname: '/detailedUserInfo',
                state: { page: 'dashboard' }
            })

        }).catch((ex) => {
            setModal(!modal)
            setModalMessaage(ex.message || ex?.data?.message || 'Something went wrong, please try again.')
        });
    }

    const handleApprove = (e, index) => {
        dispatch(showAppLoader())
        e.preventDefault()
        axioPath.post('/users/delancey-approval', {
            email: finalData[index].email
        }, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            dispatch(hideAppLoader());
            if (response.data.status === 'SUCCESS') {
                setModal(!modal)
                setModalMessaage('User request has been approved.')
            } else {
                setModal(!modal)
                setModalMessaage('Something went wrong, please try again in some time.')
            }
        }).catch((ex) => {
            dispatch(hideAppLoader());
            setModal(!modal)
            setModalMessaage(ex.message)
        });
    }

    const handleApproveWarning = (e, index) => {
        e.preventDefault()
        localStorage.setItem('WarningApprovalAccountEmail', finalData[index].email)
        setWarningApproveModal(!warningApproveModal)
    }

    const handleApproveConfirmationToggle = () => {
        setWarningApproveModal(!warningApproveModal);
        axioPath.post('/users/delancey-approval', {
            email: localStorage.getItem('WarningApprovalAccountEmail')
        }, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data.status === 'SUCCESS') {
                setModal(!modal)
                setModalMessaage('User request has been approved.')
            } else {
                setModal(!modal)
                setModalMessaage('Something went wrong, please try again in some time.')
            }
        }).catch((ex) => {
            setModal(!modal)
            setModalMessaage(ex.message)
        });
    }

    const handleReject = (e, index) => {
        e.preventDefault()
        axioPath.post('users/delancey-reject', {
            email: dataList[index].email
        }, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data.status === 'SUCCESS') {
                setModal(!modal)
                setModalMessaage('User request has been rejected.')
            } else {
                setModal(!modal)
                setModalMessaage('Something went wrong, please try again in some time.')
            }
        }).catch((ex) => {
            setModal(!modal)
            setModalMessaage(ex.message)
        });
    }

    const handleDelete = (e, index) => {
        e.preventDefault()
        localStorage.setItem('NewApprovalDeleteEmail', dataList[index].email)
        setDeleteConfirmationModal(!deleteConfirmationModal)
    }

    const handleUndo = (e, index) => {
        e.preventDefault()
        axioPath.post('/users/restore-delancey-reject', {
            email: dataList[index].email
        }, {
            headers: {
                Authorization: token,
            },
        }).then((response) => {
            if (response.data.status === 'SUCCESS') {
                setModal(!modal)
                setModalMessaage('User has been restored for approval.')
            } else {
                setModal(!modal)
                setModalMessaage('Something went wrong, please try again in some time.')
            }
        }).catch((ex) => {
            setModal(!modal)
            setModalMessaage(ex.message)
        });
    }

    const handleChange = (event, value) => {
        props.handlePagination(value, tableSearch)
        setPage(value);
        // fetchMyAPI(value, tableSearch)
    };

    const ExportFunction = async () => {
        let response = '';
        setPageLoader(true)
        response = await dispatch(addminNewUserList(1, tableSearch, props.totalNumberElement));
        if (response.statusCode === 401) {
            localStorage.removeItem('token')
            history.push('/sign-in')
            window.location.reload(false);
        }
        else {
            setPageLoader(false);
            let csvData = setCSVDate(response.data.content)
            return (csvData)
        }
        // else setPageLoader(false);
    }

    const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <Heading>
                <h3>New User Requests</h3>
                <SearchWrapper>
                    <input type="text" placeholder='Search' value={tableSearch}
                        onChange={handleSearchChange} />
                    <AiOutlineSearch />
                </SearchWrapper>
                <CsvDownloader
                    filename="New Uers List"
                    columns={columns}
                    datas={ExportFunction}>
                    <button
                        style={buttonStyle}>
                        Export
                    </button>
                </CsvDownloader>
            </Heading>
            <Table responsive>
                <thead>
                    <tr>
                        {headerArr.map((items, index) => (
                            <th key={index}>{items.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        finalData.map((items, index) => (
                            <tr key={index}>
                                {/* {items?.userDetail?.authId && */}
                                <>
                                    <td><a style={{ color: '#00b2fe', cursor: 'pointer' }}
                                        onClick={e => handleIdClick(e, index)}
                                    >{items?.userDetail?.authId}</a>
                                    </td>
                                    <td>{items?.userDetail?.registerDTO?.basicDetail?.companyName}</td>
                                    <td>{items.name}</td>
                                    <td>{items.email}</td>
                                    {items?.userDetail?.registerDTO?.accountTypeDTO?.buyer && !items?.userDetail?.registerDTO?.accountTypeDTO?.seller && <td>Buyer</td>}
                                    {!items?.userDetail?.registerDTO?.accountTypeDTO?.buyer && items?.userDetail?.registerDTO?.accountTypeDTO?.seller && <td>Seller</td>}
                                    {items?.userDetail?.registerDTO?.accountTypeDTO?.buyer && items?.userDetail?.registerDTO?.accountTypeDTO?.seller && <td>Both</td>}
                                    {/* <td>{items?.userDetail?.registerDTO?.accountTypeDTO?.reseller ? 'Yes' : 'No'}</td> */}
                                    <td>{items?.userDetail?.isReseller ? 'Yes' : 'No'}</td>
                                    <td title={items.note} style={{ minWidth: '175px' }}>
                                        {items.note?.substring(0, 50)}
                                        {items.note?.length > 50 && <span>...</span>}
                                    </td>
                                    <td title={items?.userDetail?.hearAbout} style={{ minWidth: '175px' }}>
                                        {items?.userDetail?.hearAbout?.substring(0, 50)}
                                        {items?.userDetail?.hearAbout?.length > 50 && <span>...</span>}
                                    </td>
                                    <td>{items.createdAt ? moment(items.createdAt).format('MM/DD/YYYY') : ''}</td>

                                    {items.currentUserRegistrationState === 8001 && <td style={{ display: 'flex' }}>
                                        {!items.userDetail?.notCorrectAddress ?
                                            <MdCheck title='Approve User' onClick={(e) => {
                                                handleApprove(e, index)
                                            }} style={{
                                                backgroundColor: '#3fac5d', color: 'white', borderRadius: '5px', margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer'
                                            }} />
                                            :
                                            <MdWarning title='Confirm and approve' onClick={(e) => {
                                                handleApproveWarning(e, index)
                                            }} style={{
                                                backgroundColor: '#d23f3f', color: 'white', borderRadius: '5px', margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer'
                                            }} />
                                        }
                                        <MdClear title='Reject User' onClick={(e) => {
                                            handleReject(e, index)
                                        }} style={{
                                            backgroundColor: '#d23f3f', color: 'white', borderRadius: '5px', margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer'
                                        }} />
                                        <AiOutlineDelete title='Delete User' onClick={(e) => {
                                            handleDelete(e, index)
                                        }} style={{ margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer' }} />
                                    </td>}

                                    {items.currentUserRegistrationState === 8002 && <td style={{ display: 'flex' }}>
                                        <BiUndo title='Restore User' onClick={(e) => {
                                            handleUndo(e, index)
                                        }} style={{ margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer' }} />
                                        <AiOutlineDelete title='Delete User' onClick={(e) => {
                                            handleDelete(e, index)
                                        }} style={{ margin: '0px 10px 0px 10px', height: '23px', width: '23px', cursor: 'pointer' }} />
                                    </td>}
                                </>
                                {/* } */}

                            </tr>
                        ))}
                </tbody>
            </Table>

            <Modal isOpen={modal}>
                <ModalHeader toggle={handleToggle}>Approval Status</ModalHeader>
                <ModalBody>
                    {modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleToggle}>OK</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={deleteConfirmationModal} centered={true}>
                <ModalHeader toggle={e => {
                    setDeleteConfirmationModal(!deleteConfirmationModal)
                    localStorage.removeItem('NewApprovalDeleteEmail')
                }}>
                    Delete Confirmation
                </ModalHeader>
                <ModalBody>
                    Do you want to delete this user?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleConfirmationToggle}>Yes</Button>
                    <Button color="secondary" onClick={e => {
                        setDeleteConfirmationModal(!deleteConfirmationModal)
                        localStorage.removeItem('NewApprovalDeleteEmail')
                    }}>
                        No
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={warningApproveModal} centered={true}>
                <ModalHeader toggle={e => {
                    setWarningApproveModal(!warningApproveModal)
                    localStorage.removeItem('WarningApprovalAccountEmail')
                }}>
                    Approval Confirmation
                </ModalHeader>
                <ModalBody>
                    Zip code does not match with the address. Do you still want to approve this user's request?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleApproveConfirmationToggle}>Yes</Button>
                    <Button color="secondary" onClick={e => {
                        setWarningApproveModal(!warningApproveModal)
                        localStorage.removeItem('WarningApprovalAccountEmail')
                    }}>
                        No
                    </Button>
                </ModalFooter>
            </Modal>
            {finalData.length != 0 && dataList.length !== 0 && <Pagination count={props?.pageCount}
                page={props?.currentPage}
                onChange={handleChange}
            />}

        </TableWrapper>

    )
};

export default UserRequest;



